import { Routes, Route } from "react-router-dom";

import ProtectedRoute from "../components/ProtectedRoute";
import RoleRoute from "../components/RoleRoute";
import Layout from "../components/Layout";

import Home from "../pages/Home";
import Dashboard from "../pages/Dashboard";
import Admin from "../pages/Admin";
import Login from "../pages/Login";
import OrderPage from "../pages/OrderPage";
import BillPage from "../pages/BillPage";
import PendingBillsPage from "../pages/PendingBillsPage";
import KOTManagementPage from "../pages/KOTManagementPage";
import SuperAdminSalesReport from "../pages/SuperAdminSalesReport";
import AccountLedger from "../pages/AccountLedger";
import EmployeeAttendance from "../pages/AttendancePage";
import SalaryMaster from "../pages/SalaryMaster";
import SuperAdminProducts from "../pages/SuperAdminProducts";
import SuperAdminProductCategories from "../pages/SuperAdminProductCategories";


export default function AppRoutes() {
  return (
    
      <Routes>

        <Route path="/" element={<Home />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <RoleRoute roles={["user", "admin"]}>
                  <Dashboard />
                </RoleRoute>
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/pendingbill"
          element={
            <ProtectedRoute>
              <Layout>
                <RoleRoute roles={["admin"]}>
                  <PendingBillsPage />
                </RoleRoute>
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <Layout>
                <RoleRoute roles={["superadmin", "admin"]}>
                  <AccountLedger />
                </RoleRoute>
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/attendance"
          element={
            <ProtectedRoute>
              <Layout>
                <RoleRoute roles={["superadmin", "admin"]}>
                  <EmployeeAttendance />
                </RoleRoute>
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/pendingbill/:tableId"
          element={
            <ProtectedRoute>
              <Layout>
                <RoleRoute roles={["admin"]}>
                  <PendingBillsPage />
                </RoleRoute>
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/order/:tableId"
          element={
            <ProtectedRoute>
              <Layout>
                <OrderPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route 
          path="/kot-management" 
          element={
            <ProtectedRoute>
              <Layout>
                <RoleRoute roles={["user", "admin"]}>
                  <KOTManagementPage />
                </RoleRoute>
              </Layout>
            </ProtectedRoute>
          }
          />
        
        <Route
          path="/bill/:tableId"
          element={
            <ProtectedRoute>
              <Layout>
                <BillPage />
              </Layout>
            </ProtectedRoute>
          }
        />  

        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Layout>
                <RoleRoute roles={["admin", "superadmin"]}>
                  <Admin />
                </RoleRoute>
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales-report"
          element={
            <ProtectedRoute>
              <Layout>
                <RoleRoute roles={["admin", "superadmin"]}>
                  <SuperAdminSalesReport />
                </RoleRoute>
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/products"
          element={
            <ProtectedRoute>
              <Layout>
                <RoleRoute roles={["superadmin"]}>
                  <SuperAdminProducts />
                </RoleRoute>
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/product-categories"
          element={
            <ProtectedRoute>
              <Layout>
                <RoleRoute roles={["superadmin"]}>
                  <SuperAdminProductCategories />
                </RoleRoute>
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/salary-master"
          element={
            <ProtectedRoute>
              <Layout>
                <RoleRoute roles={["admin", "superadmin"]}>
                  <SalaryMaster />
                </RoleRoute>
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route path="/login" element={<Login />} />

      </Routes>
   
  );
}
